import {Amplify} from 'aws-amplify';
import awsExports from './aws-exports';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from "@aws-amplify/ui-react";
import { BrowserRouter } from "react-router-dom";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@aws-amplify/ui-react/styles.css';
import { setAuthCreateTabAndButtonLabel } from "./auth/authI18n";

setAuthCreateTabAndButtonLabel("create");

Amplify.configure(awsExports);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
